import { render } from "./PrivacyBrandPartners.vue?vue&type=template&id=0bf016b7"
const script = {}

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__